<template>
  <div class="bg-container">
    <div class="login">
      <div class="topbar">
        <span class="mark"></span>
        <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
          <template #reference>
            <van-button type="primary" plain>{{languageText}}</van-button>
          </template>
        </van-popover>
      </div>
      <div class="logo">
        <img src="/img/login/logo2.png" alt="">
      </div>
      <div class="form">
        <div class="input_wrap">
          <van-icon name="contact-o" size="18" color="#bfa06a"></van-icon>
          <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
        </div>
        <div class="input_wrap">
          <van-icon name="lock" size="18" color="#bfa06a"></van-icon>
          <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
          <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#bfa06a" size="18" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
        </div>
        <div class="button" @click="doLogin()">{{$t("auth.login")}}</div>
        <div class="row" @click="toRegister">{{$t("auth.no_account")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { LANGS, setLangManual } from "@/common/languages";
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pwdType: 1,
      username: "",
      lang: 'en_us',
      password: this.inputValue,
      passwordType: "password",
      showPopover: false,
      languageText: '',
      actions: LANGS.map(item => ({ text: item.name, code: item.code })),
    };
  },
  mounted(){
    // localStorage.setItem("lang", 'ms_my');
    this.lang = localStorage.getItem("lang") || 'en_us';
    this.actions.map(item => {
      if(item.code === this.lang) {
        this.languageText = item.text
      }
    })
  },
  methods: {
    onSelect(e) {
      Toast.loading({
        duration: 200,
      });
      this.$i18n.locale = e.code;
      this.languageText = e.text;
      localStorage.setItem("lang", e.code);
      setLangManual();  // 手动选择优先，之后不再被 IP / 注册地区覆盖
      // if (this.source=='setting'){
      //   this.$router.push({path:'/'});
      // }else{
      //   this.$router.go(-1);
      // }
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: { 
          username: this.username, 
          password: this.password,
          lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$applyLoginLang(res.data.reg_lang); // 登录后按注册地区语言切换
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.bg-container {
  background: @bg-page;
  height: 100%;
}
.login {
  height: 100%;
  width: 100%;
  padding: 0 1.7rem 2rem;
  background: @bg-page;
  overflow: auto;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 0.12rem;
    background: @gold;
  }
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 1.15rem;
  .mark {
    width: 1.8rem;
    height: 1px;
    background: @gold;
  }
}

.logo {
  width: 9.2rem;
  margin: 2.6rem 0 0.7rem;
  img{
    width: 100%;
    display: block;
    filter: brightness(0) saturate(100%);
    opacity: 0.88;
  }
}

.form {
  margin-top: 1.6rem;
  padding-top: 0.4rem;
  border-top: 1px solid @line;
}

.input_wrap{
  height: 3.55rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid @line;
  input{
    flex: 1;
    width: 0;
    height: 100%;
    border: none;
    background: none;
    outline: none;
    text-align: left;
    font-size: .95rem;
    margin-left: 0.75rem;
    color: @text-title;
    &::placeholder {
      color: @text-sub;
    }
  }
}

.row {
  font-size: 0.92rem;
  color: @wine;
  font-weight: 500;
  margin: 1.35rem 0 0;
  text-align: left;
}

.button{
  width: 100%;
  background: @wine;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.06rem;
  color: #fff;
  text-align: center;
  height: 3.15rem;
  line-height: 3.15rem;
  border-radius: 0.12rem;
  margin: 2rem 0 0;
}
.van-button {
  height: 1.7rem;
  line-height: 1.7rem;
  padding: 0 0.15rem;
  font-size: 0.86rem;
  background: transparent;
  border: none;
  color: @text-body;
  border-radius: 0;
}
::v-deep .van-popover__action-text {
  font-size: 0.88rem;
}
</style>
